export class ManufacturingOrderFilter {
  constructor(
    public code?: number,
    public display?: string
  ) { }

  clone() {
    return new ManufacturingOrderFilter(
      this.code,
      this.display
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-filter.ts